import { createPersist } from 'api/helper'
import { callCloudFunction } from 'utils/cloudbase'
import { SwiperModel } from './types'

/**
 * 获取首页幻灯片
 * @description 缓存15分钟
 */
export const getSwipers = createPersist(async (): Promise<SwiperModel[]> => {
    const resp = await callCloudFunction({
        action: 'getSwipers'
    }) as SwiperModel[]

    return resp || []
}, 'swipers', 15 * 60)